import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '@core/components/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  constructor(private snackBar: MatSnackBar) { }

  public openSnackBar(message: string, snackType: string, action?: string, isSticky?: boolean,token?:string) {
    const _snackType: string = snackType !== undefined ? snackType : 'Success';
    const ref = this.snackBar.openFromComponent(SnackbarComponent, {
      duration: isSticky ? 0 : 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      data: { message: message, action: action, snackType: _snackType, isSticky ,token:token},
    });
    let barclass = document.querySelectorAll('.mat-mdc-snack-bar-label');
    for (let i = 0; i < barclass.length; i++) {
      barclass.forEach((ele) => {
        ele.classList.remove('success-snackbar');
        ele.classList.remove('error-snackbar');
        ele.classList.remove('info-snackbar');
        ele.classList.remove('warning-snackbar');
        switch (snackType) {
          case 'Success':
            ele.classList.add('success-snackbar');
            break;
          case 'Error':
            ele.classList.add('error-snackbar');
            break;
          case 'Warn':
            ele.classList.add('warning-snackbar');
            break;
          case 'Warn 2':
            ele.classList.add('warning-snackbar');
            break;
          case 'Info':
            ele.classList.add('info-snackbar');
        }
      });
    }
    return ref;
  }
}
